import { useLayoutEffect } from 'react';
import { Grid } from '@mui/material';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useQuery } from 'react-query';
import { UpdateAppSubHeaderTitle } from '../../redux/actions/UiActions';
import { getAlcaldias } from '../../api/Alcaldia';
import CenterLoading from '../../components/CenterLoading/CenterLoading';
import TextInformation from '../../components/TextInformation/TextInformation';
import { MediumHeightDivider, SmallHeightDivider } from '../../theme/Styles';
import {
    Container,
    AlcaldiaCard,
    AlcaldiaLogo,
    AlcaldiaName,
    AlcaldiaInfo,
    AlcaldiaButton,
} from './styles/AlcaldiasListStyles';

function AlcaldiasList() {
    const history = useHistory();
    const dispatch = useDispatch();

    const { data: alcaldias, isLoading } = useQuery(
        ['alcaldias'], 
        () => getAlcaldias(),
        {
            refetchOnWindowFocus: true,
            staleTime: 30000,
        }
    );

    useLayoutEffect(() => {
        dispatch(UpdateAppSubHeaderTitle('Ayuntamientos'));
    }, []);

    if (isLoading) return <CenterLoading />;

    return (
        <Container>
            <TextInformation
                title="Ayuntamientos"
                content="Consulta los trámites y servicios disponibles en cada alcaldía municipal."
            />
            <SmallHeightDivider />
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="flex-start"
                spacing={3}
            >
                {(alcaldias || []).map((alcaldia) => (
                    <Grid item key={alcaldia.id}>
                        <AlcaldiaCard onClick={() => history.push(`/app/alcaldias/${alcaldia.id}`)}>
                            {alcaldia.logo_url ? (
                                <AlcaldiaLogo src={alcaldia.logo_url} alt={alcaldia.name} />
                            ) : null}
                            <AlcaldiaName>{alcaldia.name}</AlcaldiaName>
                            {alcaldia.municipality ? (
                                <AlcaldiaInfo>{alcaldia.municipality}</AlcaldiaInfo>
                            ) : null}
                            {alcaldia.phone ? (
                                <AlcaldiaInfo>{alcaldia.phone}</AlcaldiaInfo>
                            ) : null}
                            {alcaldia.schedule ? (
                                <AlcaldiaInfo>{alcaldia.schedule}</AlcaldiaInfo>
                            ) : null}
                            <AlcaldiaButton variant="contained" disableElevation>
                                Ver trámites
                            </AlcaldiaButton>
                        </AlcaldiaCard>
                    </Grid>
                ))}
            </Grid>
            {(!alcaldias || alcaldias.length === 0) && (
                <TextInformation content="No hay alcaldías disponibles en este momento." />
            )}
            <MediumHeightDivider />
        </Container>
    );
}

export default AlcaldiasList;
